<template>
    <div class="pai-bg">
        <div class="pai-container">
            <div class="pai-title" style="font-size:14px;line-height:20px;text-align:left;padding:10px;height:auto;">请认真、仔细地填写以下信息，严肃的商业信息有助于您获得别人的信任，获取商业机会！</div>
            <div class="pai-from">
                <label class="pai-input"><span>姓 名：</span><input type="text" v-model="form.name"></label>
                <label class="pai-input"><span>公司全称：</span><input type="text" v-model="form.company"></label>
                <label class="pai-input"><span>详细地址：</span><textarea v-model="form.address"></textarea></label>
                <label class="pai-input"><span>所属行业：</span><input type="text" v-model="form.profession"></label>
                <label class="pai-input"><span>手机号：</span><input type="text" v-model="form.tel"></label>
                <label class="pai-input"><span>邮 箱：</span><input type="text" v-model="form.email"></label>
                <button @click="subForm">查看会员福利</button>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs';

export default {
    metaInfo: {
        title: "拍界——唤醒您的沉睡资产",
        meta: [{
            name: "keywords",
            content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }, {
            name: "description",
            content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }]
    },
    data (){
        return{
            form: {
                name: '',
                company: '',
                address: '',
                profession: '',
                tel: '',
                email: '',
            },
        }
    },
    created(){
        // 显示公共栏
        this.$emit('header', true)
        this.$emit('footer', true)
        // 页面至顶部
        window.scrollTo(0,0);
        let isV = 0
        isV = localStorage.getItem('vip')
        if (isV==1) {
            this.$router.push('/serivce2')
        }
    },
    methods: {
        subForm: function(){
            let forms = qs.stringify(this.form)
            this.axios.post(this.$global.apiUrl.vip, forms, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then((response) => {
                    if (response.data.error.code == 0){
                        localStorage.setItem('vip', 1)
                        this.$alert('提交成功', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$router.push('/serivce2')
                            }
                        })
                    }
                    else{
                        this.$alert(response.data.error.message, '提示', {
                            confirmButtonText: '确定'
                        })
                    }
                })
        }
    },
    mounted(){
        
    },
    computed: {

    }
}
</script>
<style scoped>
.pai-bg {
    width: 1200px;
    height: 675px;
    background: url("../assets/images/pai_bg.png");
}
.pai-container {
    width: 450px;
    min-height: 500px;
    box-shadow: 0px 5px 5px 3px #888888;
    margin: 50px 0 0 650px;
    padding-bottom: 30px;
    background: #FFFFFF;
}
.pai-title {
    font-size: 18px;
    color: #c71622;
    height:50px;
    line-height:50px;
    border-bottom: 2px solid #adadad;
}
.pai-input {
    display: block;
    margin-top: 20px;
    text-align: right;
}
.pai-input span {
    margin-right: 20px;
    line-height: 30px;
    vertical-align: top;
}
.pai-input input {
    padding:6px 10px;
    border:solid 1px #cccccc;
    margin-right: 70px;
    width: 200px;
}
.pai-input textarea {
    padding:6px 10px;
    border:solid 1px #cccccc;
    margin-right: 70px;
    width: 200px;
    height:50px;
    vertical-align: top;
}
.pai-input .pai-images {
    height:100px;
    margin-right: 70px;
    margin-top:10px;
}
.pai-from button {
    width: 198px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    border: 1px solid transparent;
    background: #d6363b;
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    margin-top: 20px;
}
@media screen and (max-width: 540px){
    .pai-bg {
        width: 100%;
        height: 675px;
        background: url("../assets/images/pai_bg.png");
    }
    .pai-container {
        width: 330px;
        min-height: 500px;
        box-shadow: 0px 5px 5px 3px #888888;
        margin: 50px auto;
        padding-bottom: 30px;
        background: #FFFFFF;
    }
    .pai-title {
        font-size: 18px;
        color: #c71622;
        height:50px;
        line-height:50px;
        border-bottom: 2px solid #adadad;
    }
    .pai-input {
        display: block;
        margin-top: 20px;
        text-align: right;
    }
    .pai-input span {
        margin-right: 15px;
        line-height: 30px;
        vertical-align: top;
    }
    .pai-input input {
        padding:6px 10px;
        border:solid 1px #cccccc;
        margin-right: 25px;
        width: 160px;
    }
    .pai-input textarea {
        padding:6px 10px;
        border:solid 1px #cccccc;
        margin-right: 25px;
        width: 160px;
        height:50px;
        vertical-align: top;
    }
}
</style>